import { render, staticRenderFns } from "./abstract-service-details-modal.vue?vue&type=template&id=2b86a518&scoped=true"
import script from "./abstract-service-details-modal.vue?vue&type=script&lang=js"
export * from "./abstract-service-details-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86a518",
  null
  
)

export default component.exports